// Oyun sağlayıcıları listesi
// Slug'lar isimden otomatik üretilir ki tek kaynak isim olsun.

const rawProviders = [
  "High5",
  "iSoftBet",
  "Stakelogic",
  "Superlotto",
  "WorldMatch",
  "1x2gaming",
  "4ThePlayer",
  "Men Faming",
  "Mojos Slots",
  "AllwaySpin",
  "Amatic",
  "Apollo",
  "AuthenticGaming",
  "Bally Wulff",
  "Baletra",
  "Bet2Tech",
  "Betsoft",
  "Betsolutions",
  "BF Gaming",
  "Bgaming",
  "Big Time Gaming",
  "Blackpudding",
  "Blueprint",
  "Booming",
  "Booongo",
  "Boomerang",
  "Caleta",
  "Champion",
  "CQ9",
  "CT Gaming",
  "EA Gaming",
  "Edgevirtuals",
  "EGT",
  "Elbet",
  "Electric Elephant",
  "ELK",
  "Endorphina",
  "Evolution",
  "Evoplay",
  "Eyecon",
  "Fantasma",
  "Fazi",
  "Felt",
  "Fugaso",
  "Games Inc",
  "Games Lab",
  "Gamomat",
  "Gamomat Premium",
  "Gamomat Standard",
  "Gamshy",
  "Gamzix",
  "Ganapati",
  "Golden Hero Games",
  "Golden Race",
  "Green Jabe",
  "Habanero",
  "Hacksaw",
  "High Fluer Games",
  "Hogaming",
  "Holle Games",
  "Igrosoft",
  "Iron Dog Studios",
  "KA Gaming",
  "Kalamba",
  "Kiron",
  "Leander",
  "Leap",
  "Liw",
  "Mancala Gaming",
  "Matrix Studio",
  "MG",
  "Mr Slotty",
  "NetEnt",
  "Netgame",
  "NSoft",
  "One Touch",
  "Oryx",
  "Pariplay",
  "PG Soft",
  "Platipus",
  "Play Pearls",
  "Playbro",
  "Play'n GO",
  "Playson Direct",
  "Playtech",
  "Playzido",
  "Pragmatic Play",
  "Push Gaming",
  "Quickspin",
  "Red Rake",
  "Red Tiger",
  "ReelPlay",
  "Relax Gaming",
  "Retro Games",
  "Revolver",
  "RubyPlay",
  "Segaming",
  "Silverback",
  "SimplePlay",
  "Skywind",
  "Spinmatic",
  "Spribe",
  "Spinomenal",
  "Tom Horn",
  "TV Bet",
  "TrueLab",
  "UP Gaming",
  "Vegaming",
  "Virtual Generation",
  "Vivo Gaming",
  "Wazdan",
  "Yggdrasil",
  "ReelNRG",
  "Nolimit City",
];

const slugify = (name) =>
  name
    .toLowerCase()
    .replace(/['’]/g, "") // apostrofları sil
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const providers = rawProviders.map((name) => ({
  name,
  slug: slugify(name),
}));

